

import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Utils } from "@/service/util";
import RecommendMaintenance from "@/page/factory/recMaintenance.vue";
import { Getter, Action } from "vuex-class";
import {
  InspectRecommend,
  InspectRecommendCategory,
  InspectRecommendSubItem
} from "@/model/InspectRecommend";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";

import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { MESSAGE } from "@/model/Message";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";

@Component({
  components: {
    InputNumber,
    ConfirmDialog
  }
})
export default class RecommendMaintenanceQuick extends RecommendMaintenance {
  @Prop()
  socketPath: any;

  carFormQuickInfo: CarSelectQuickInfoData = {} as CarSelectQuickInfoData;

  public utils: Utils = new Utils();

  @Getter("currentState", { namespace: "CarSelectionQuickInfo" })
  currentStateQuickInfo: CarSelectQuickInfoData;

  onRegister() {
    // console.log("RecommendMaintenanceQuick.onRegister => route.name ", this.$route.name);
    this.$emit("onregister", { pageName: this.$route.name });
    this.$emit("onGetInspectRecommend");
  }

  onConfirmBuhin(item: InspectRecommendSubItem) {
    item.isDoTenken = 1;
    this.changeStatus(item);
    this.saveSeibiItem(item);
  }
  
  showAll() {
    if (this.isShowAll(1)) {
      return;
    }
    this.currentData.forEach((item: any) => {
      item.osusumeIsShow = 1;
      if (!item.buhinBunruiList || (item.buhinBunruiList && item.buhinBunruiList.length == 0)) {
        item.isDoTenken = 1;
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      }
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeStatus(item);
    });
    this.saveCurrentData();
  }

  /** 2021-07-30 sh #6989 override for quick mitsumori. [START] */
  /** クイック見積もりでは、QR情報は不要なため、オーバーライドをしておく */
  initData(res: any) {
    const initialState = this.pageService.buildInitialDataState(
      res,
      this.changeStatus.bind(this),
      this.setCateStatus.bind(this),
      this.maxRowNum
    );
    if (initialState.hasRecommend) {
      this.maxRowNum = initialState.maxRowNum;
      Promise.all(initialState.categories).then((val: any) => {
        this.data = initialState.data;
        this.setInspect(this.data);
        this.setCurrentData();
      });
    }
  }
  /** 2021-07-30 sh #6989 override for quick mitsumori. [END] */

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  saveAndUpdateData(data: any, isUpdateAll: boolean = false) {
    this.isSaving = true;
    let sendData = {
      socketPath: this.socketPath,
      ...data
    };
    this.pageService.saveInspectRecommendQm(sendData).then( // sendSocket:ソケット仮07
      (res: any) => {
        if (res.status == 200 && res.body) {
          this.isSocket = true;
          this.isSaving = false;
          data.recommend[0].subItems
            .map((item: any) => item.sknRecommendInspecSeibiId)
            .forEach((key: number) => {
              const target = this.currentData.findIndex(
                (i: InspectRecommendSubItem) =>
                  i.sknRecommendInspecSeibiId === key
              );
              if (target > -1) {
                this.currentData[target].isSaving = false;
              }
            });
          this.timerSave = setTimeout(() => {
            if (this.tempWaitSave.length > 0) {
              const data2 = this.getObjForSave(this.utils.deepCopy(this.tempWaitSave));
              this.saveAndUpdateData(data2);
              this.tempWaitSave = [];
            }
          }, 1000);
          this.tempListSave = [];
          this.arrStatus = [];
          this.initData(res.body);
        }
      },
      (error: any)  => {
        console.error("error", error.rsltComment);
        let arrNm = this.tempListSave.map(
          inspect => inspect.sknRecommendInspecSeibiNm
        );
        if (arrNm.length > 0) {
          this.$notify.error({
            title: "エラー",
            message: arrNm.join()
          });
        }
      }
    );
  }

  /** なぜかsaveAndUpdateDataが、2回呼ばれるので、オーバーライドしてみる */
  onCloseBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    if (event.isResetSeibi || event.isChange) {
      if (event.isSocket) {
        this.isSocket = true;
      } else {
        this.isSocket = false;
      }
      this.changeStatus(this.activeInspect);
      const data = this.getObjForSave(this.activeInspect);
      // this.saveAndUpdateData(data); // これが2回呼ばれる
    }
    this.$set(this, "activeInspect", {});
  }
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */
}
